import React from "react";
import {
  LuCalendarCheck,
  LuMail,
  LuMessageCircleMore,
  LuSmartphone,
} from "react-icons/lu";
import "./ContactAdmissionsStrip.css";

export default function ContactAdmissionsStrip({
  onAppointmentClick,
  phoneText = "022 - 67308301/02",
  phoneHref = "tel:02267308301",
}) {
  return (
    <section className="peo-contact-strip" aria-label="Contact admissions">
      <div className="peo-contact-inner">
        <div className="peo-contact-art" aria-hidden="true">
          <span className="peo-contact-device">
            <LuSmartphone />
          </span>
          <span className="peo-contact-envelope">
            <LuMail />
          </span>
          <span className="peo-contact-bubble">
            <LuMessageCircleMore />
          </span>
        </div>

        <div className="peo-contact-copy">
          <span>If you have any questions</span>
          <p>
            Call Us On <a href={phoneHref}>{phoneText}</a>
          </p>
        </div>

        <button
          className="peo-appointment-btn"
          type="button"
          onClick={onAppointmentClick}
        >
          <LuCalendarCheck aria-hidden="true" />
          Enquire
        </button>
      </div>
    </section>
  );
}
